var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomCritical = function SvgCustomCritical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 16.656a.325.325 0 0 1-.328.334h-4.897a.354.354 0 0 1-.346-.333 4.441 4.441 0 0 0-.92-2.39l3.948-3.948A10.005 10.005 0 0 1 22 16.656ZM18.67 9.533A10.006 10.006 0 0 0 12.557 7v5.584c.79.1 1.538.41 2.167.897l3.948-3.948ZM9.277 13.481a4.442 4.442 0 0 1 2.167-.897V7A10.006 10.006 0 0 0 5.33 9.533l3.949 3.948ZM4.543 10.319A10.005 10.005 0 0 0 2 16.656a.325.325 0 0 0 .328.334h4.897c.184 0 .332-.15.346-.333a4.441 4.441 0 0 1 .92-2.39L4.543 10.32Z",
    fill: "currentColor"
  })));
};

export default SvgCustomCritical;